<template>
  <TsCarouselV2
    v-if="props.data.length > 0"
    :navigation="!isMobile"
    :pagination="isMobile"
    :no-of-slides="props.data.length"
    container-class="gap-2"
    :data-testid="props.dataTestid"
  >
    <!-- SLIDES -->
    <div
      v-for="item in props.data"
      :key="item.id"
      class="embla__slide shrink-0 basis-[132px] md:basis-[148px]"
      :data-testid="props.dataTestid + '-item'"
    >
      <component
        :is="item.landingPageUrl ? NuxtLinkWithLocale : 'div'"
        :to="item.landingPageUrl"
        :class="twMerge('relative rounded-lg overflow-hidden block')"
      >
        <TsImage
          v-if="item.image"
          :src="`${item.image}?width=148&height=148&format=webp`"
          :alt="item.image_alt"
          class="w-full"
          :width="isMobile ? '132' : '148'"
          :height="isMobile ? '132' : '148'"
          loading="lazy"
        />

        <!-- Offer tag -->
        <TsTypography
          v-if="item.image_tag"
          variant="xs"
          align="center"
          append-class="
            absolute top-0
            w-full
            px-1 py-2.5
            text-white
            text-base
            font-bold
            leading-[12px]
          "
        >
          {{ item.image_tag }}
        </TsTypography>
      </component>

      <!-- Title -->
      <component
        :is="item.landingPageUrl ? NuxtLinkWithLocale : 'div'"
        v-if="item.title"
        :to="item.landingPageUrl"
        class="mt-3 block"
      >
        <TsTypography
          variant="sm"
          align="center"
          weight="semibold"
          size="sm"
          append-class="mb-0 text-natural-black hyphens-auto"
        >
          <span v-html="item.title" />
        </TsTypography>
      </component>
    </div>
  </TsCarouselV2>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';
import TsCarouselV2 from './TsCarouselV2.vue';
const { isMobile } = useDevice();
type Data = {
  id: number;
  landingPageUrl?: string;
  image: string;
  image_alt: string;
  image_tag: string;
  title: string;
};

type Props = {
  data?: Data[];
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  data: () => [
    {
      id: 1,
      image: '/images/screws.png',
      image_alt: 'Get up to 50% off on screws',
      image_tag: 'Get up to 50% off',
      title: 'Screws & Fasteners',
    },
    {
      id: 2,
      image: '/images/battries.png',
      image_alt: 'Get up to 50% off on batteries',
      image_tag: 'Get up to 50% off',
      title: 'Batteries & Chargers',
    },
    {
      id: 3,
      image: '/images/cordless.png',
      image_alt: 'Get up to 50% off on cordless tools',
      image_tag: 'Get up to 50% off',
      title: 'Cordless Tool',
    },
    {
      id: 4,
      image: '/images/trouser.png',
      image_alt: 'Get up to 50% off on trousers',
      image_tag: 'Get up to 50% off',
      title: 'Work Trousers',
    },
    {
      id: 5,
      image: '/images/grinding.png',
      image_alt: 'Get up to 50% off on grind tools',
      image_tag: 'Get up to 50% off',
      title: 'Grinding Machines',
    },
    {
      id: 6,
      image: '/images/mowers.png',
      image_alt: 'Get up to 50% off on lawn mowers',
      image_tag: 'Get up to 50% off',
      title: 'Lawn Mowers',
    },
    {
      id: 7,
      image: '/images/hammers.png',
      image_alt: 'Get up to 50% off on hammers',
      image_tag: 'Get up to 50% off',
      title: 'Hammer',
    },
    {
      id: 8,
      image: '/images/showers.png',
      image_alt: 'Get up to 50% off on showers',
      image_tag: 'Get up to 50% off',
      title: 'Taps & Showers',
    },
  ],
  dataTestid: '',
});

const NuxtLinkWithLocale = resolveComponent('NuxtLinkWithLocale');
</script>
